import { createContext, useContext } from 'react'
import { DEFAULT_BUDDY, SproutBuddy, type Buddy, type Mood } from './SproutBuddy'

export type { Mood }

/**
 * The buddy of the child whose part of the app this is (App's ChildSpace
 * provides it). Sam, 18 Oct 2026: a child's own Sprout Buddy should be the
 * one on every page while they are in their account, not the brand one.
 * Outside a child's space (Home, the grown-up's screens) it is null.
 */
export const ChildBuddy = createContext<Buddy | null>(null)

/**
 * Sprout, the Word Sprout mascot, wherever the app shows the brand.
 *
 * Since 8 Oct 2026 this is the Sprout Buddy from Sam's mascot sheets (see
 * SproutBuddy.tsx): an orange teardrop with two leaves on top. Until then it
 * was a round green seed drawn here. Every screen that already showed Sprout
 * picked up the new one through this file, without being touched.
 *
 * Pass `buddy` to show a child's own buddy instead of the brand one.
 */
export function Mascot({
  size = 96, mood = 'happy', animate = true, label = 'Sprout', buddy,
}: {
  size?: number
  mood?: Mood
  animate?: boolean
  label?: string
  buddy?: Buddy | null
}) {
  const theirs = useContext(ChildBuddy)
  return (
    <SproutBuddy
      buddy={buddy ?? theirs ?? { ...DEFAULT_BUDDY, held: mood === 'cheer' ? 'none' : DEFAULT_BUDDY.held }}
      mood={mood}
      size={size}
      animate={animate}
      label={label}
    />
  )
}
